import { defineStore } from 'pinia';
import { run } from '@/repository/bbay';
import { Constants, type Bbay } from '@fibl/oxs-common';

export const useBbayStore = defineStore('bbay', {
	state: () => ({
		cache: [] as { key: string; facts: unknown }[],
	}),

	getters: {
		cachedDecision() {
			return (key: string) => {
				return this.cache.find((e) => e.key === key)?.facts;
			};
		},
	},

	actions: {
		async evaluate<T>(
			{ id, alias, rev }: { id?: string; alias?: string; rev?: number },
			facts: T,
		): Promise<T> {
			let key = JSON.stringify({ id, alias, rev, facts });
			let output = this.cachedDecision(key) as T;
			if (!output) {
				let res = await run<T>({ ruleset: { id, rev, alias }, facts });
				// console.log('bbay evaluated', { id, alias, rev, facts, output: res });
				output = res.facts;
				this.cache.push({
					key,
					facts: output,
				});
			} else {
				// console.log('cached bbay', output);
			}
			return output;
		},

		runClassifications(env: Bbay.ClassificationCheck): Promise<Bbay.ClassificationCheck> {
			return this.evaluate<Bbay.ClassificationCheck>(
				{ alias: Constants.ALIAS.CLASSIFICATIONS },
				env,
			);
		},

		runRequestUnits(env: Bbay.RequestUnits): Promise<Bbay.RequestUnits> {
			return this.evaluate<Bbay.RequestUnits>({ alias: Constants.ALIAS.REQUNITS }, env);
		},
	},
});
